import { Component,OnInit, ViewChild } from '@angular/core';
import { MatDialog} from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Service } from 'src/app/services';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { PaymentShippingComponent } from './components/payment-shipping/payment-shipping.component';
interface dataBuyProcces {
  dataPlan: any,
  additionalService: any,
  streaming: any,
}
interface dataAdditionalService {
  items: items[],
  checkDVR: boolean,
  priceDVR: number,
  rent: number
};
interface items {
  id: string,
  name: string,
  price: number
}
@Component({
  selector: 'app-buy-process',
  templateUrl: './buy-process.component.html',
  styleUrls: ['./buy-process.component.sass']
})
export class BuyProcessComponent implements OnInit {
  @ViewChild(PaymentShippingComponent, { static: false }) topay: PaymentShippingComponent;
  public tabActive = 'Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public content: object;
  public panelOpenState;
  public expand: boolean[] = [false, false, false, false, false];
  public dataPlan: any;
  public rentalAdditionalServices: number = 0;
  public checkDVR: boolean = false;
  public rentalStreaming: number = 0;
  public infoStreaming: any;
  public payTodayPlan: number = 0;
  public payTodayAdditionalServices: number = 0;
  public payTodayStreaming: number = 0;
  public dataAdditionalService: dataAdditionalService[] = [];
  public dataBuyProcces: dataBuyProcces;
  public premiumChannels = [];
  public sva: any = [];
  public svaBitInclude: any = [];
  public svaCart: any = [];
  public currentParentCartId: number = 0;
  public currentParentProductId: number = 0;
  public currentIndex: number = 0;
  public itemsCart: any;
  public changeSva: boolean = false;
  public indexSva: number = 0;
  public svaIptv: boolean = false;
  public planSelected: any;
  public selectMonthlyRent: any = [];
  public selectsToDisplay: any = [];
  public maximumString: number = 60;
  public selectPayToday: any = [];
  public noThanks: boolean = false;
  public viewSVA: boolean = false;
  public dataLoaded: boolean = false;
  public streamingActive = false;
  public valueAddres: boolean = false;
  public dataShippingAddress: any;
  public installments: number = 0;
  public contract: boolean = false;
  public svaProducts: boolean = false;
  public selectsToDisplayFull: any = [];
  public accountValidation: boolean = false;
  public paymentValidation: boolean = false;
  public shippingValidation: boolean = false;
  public streamingValidation: boolean = false;
  public disabled = [];

  constructor(public dialog: MatDialog, private services: Service, private loadingScreenService: LoadingScreenService, public global: GlobalService, private router: Router, private route: ActivatedRoute) {
    for (let i = 0; i < 6; i++) {
      this.disabled[i] = true;
    }
    let w: number;
    this.global.resizeObservable.subscribe((e: any) => {
      if (e.target.innerWidth !== w) {
        this.resizeSetup();
      }
      w = e.target.innerWidth;
    });
    this.global.tokenShop = sessionStorage.getItem("tokenShop");
  }
  ngOnInit(): void {
    this.global.screenEnabled = false;
    this.getCart();
  }
  initializeData() { }
  resizeSetup() {
    if (window.innerWidth > 500) {
      this.selectsToDisplay[0] = this.global.textShortener(this.selectsToDisplayFull[0], "", 46, "...");
      this.selectsToDisplay[1] = this.global.textShortener(this.selectsToDisplayFull[1], "", 46, "...");
      this.selectsToDisplay[2] = this.global.textShortener(this.selectsToDisplayFull[2], "", 46, "...");
      this.selectsToDisplay[5] = this.global.textShortener(this.selectsToDisplayFull[5], "", 46, "...");
    }
    else if (window.innerWidth > 440 && window.innerWidth <= 500) {
      this.selectsToDisplay[0] = this.global.textShortener(this.selectsToDisplayFull[0], "", 15, "...");
      this.selectsToDisplay[1] = this.global.textShortener(this.selectsToDisplayFull[1], "", 10, "...");
      this.selectsToDisplay[2] = this.global.textShortener(this.selectsToDisplayFull[2], "", 10, "...");
      this.selectsToDisplay[5] = this.global.textShortener(this.selectsToDisplayFull[5], "", 30, "...");
    }
    else {
      this.selectsToDisplay[0] = this.global.textShortener(this.selectsToDisplayFull[0], "", 8, "...");
      this.selectsToDisplay[1] = this.global.textShortener(this.selectsToDisplayFull[1], "", 5, "...");
      this.selectsToDisplay[2] = this.global.textShortener(this.selectsToDisplayFull[2], "", 5, "...");
      this.selectsToDisplay[5] = this.global.textShortener(this.selectsToDisplayFull[5], "", 15, "...");
    }
  }
  scrollToAnchor(anchor: string) {
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/buy_process'], { fragment: anchor }).finally(() => {
      this.router.onSameUrlNavigation = 'ignore';
    });
  }
  validatePanels(index: number, message: string) {
    this.openTab(index);
    let dialogRef = this.global.notif(message);
    dialogRef.afterClosed().subscribe(data => {
      this.scrollToAnchor('panel_' + index);
    });
  }
  checkOrder() {
    if (this.accountValidation == false) {
      this.validatePanels(2, 'Por favor crea tu cuenta');
    }
    else if (this.streamingValidation == false && this.itemsCart.bitEquipmentValidate == false) {
      this.validatePanels(3, "Por favor escoja un dispositivo streaming");
    }
    else if (this.paymentValidation == false) {
      this.validatePanels(4, "Por favor completa la información de pago");
    }
    else if (this.shippingValidation == false) {
      this.validatePanels(5, "Por favor completa  la información de envio");
    }
    else {
      this.topay.paymentGeneral(this.itemsCart.totalPrice, this.itemsCart.depositAmount);
    }
  }
  verifyAdditionalService() {
    return true;
  }
  verifyStreamingDevice() {
    return true;
  }
  verifyPaymentMethod() {
    return true;
  }
  verifyShippingAddress() {
    return true;
  }
  processOrder() {
    this.router.navigate(['iptv_create_account']);
  }
  updateDVR(check: boolean, price: number) {
    if (check) {
      this.rentalAdditionalServices += price;
    }
  }
  updateDataAdditionalService(data: any, checkDVR: boolean, priceDVR: number) {
    this.checkDVR = checkDVR;
    this.rentalAdditionalServices = 0;
    this.dataAdditionalService = [];
    let dataInterface: dataAdditionalService;
    dataInterface = { items: [], checkDVR: checkDVR, priceDVR: priceDVR, rent: 0 };
    for (let i = 0; i < this.premiumChannels.length; i++) {
      for (let j = 0; j < this.premiumChannels[i].length; j++) {
        for (let z = 0; z < data.length; z++) {
          if (this.premiumChannels[i][j].idChannel == data[z]) {
            dataInterface.items.push(
              {
                id: this.premiumChannels[i][j].idChannel,
                name: this.premiumChannels[i][j].name,
                price: this.premiumChannels[i][j].price
              });
            this.rentalAdditionalServices += this.premiumChannels[i][j].price;
          }
        }
      }
    }
    if (this.checkDVR) {
      this.rentalAdditionalServices += priceDVR;
    }
    dataInterface.rent = this.rentalAdditionalServices;
    this.dataAdditionalService.push(dataInterface);
  }
  loadStreaming() {
    this.streamingActive = false;
    this.loadingScreenService.startLoading();
    this.services.productsIPTV(this.global.tokenShop).subscribe((data: any) => {
      this.loadingScreenService.stopLoading();
      if (data.hasError == false) {
        this.infoStreaming = data;
        this.dataLoaded = true;
        this.streamingActive = true;
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.errorDesc);
      }
    });
  }
  loadRentalStreaming(info: any) { }
  subtotal() {
    let total: number = this.dataPlan.price + this.rentalAdditionalServices + this.rentalStreaming;
    return total;
  }
  payToday() {
    let total: number = this.payTodayPlan + this.payTodayAdditionalServices + this.payTodayStreaming;
    return total;
  }

  getCart(state: boolean = true) {
    this.loadingScreenService.startLoading();
    this.global.getCart().subscribe((data: any) => {
      this.global.totalAmount = data.totalPrice;
      this.itemsCart = data;
      this.dataPlan = data.products[0];
      if (data.products.length > 0) {
        this.setCurrentIndex().subscribe((result: any) => {
          this.currentParentProductId=this.dataPlan.productId;
          this.services.plansIPTV(this.dataPlan.productId, this.global.tokenShop).subscribe((sva: any) => {
            this.loadingScreenService.stopLoading();
            this.sva = sva.plans;
            this.searchBitIncludeIptv();
            this.loadSva();
            this.loadStreaming();
            if (this.itemsCart.bitAccountValidate == true) {
              this.accountValidation = true;
              this.disabled[3] = false;
              if (sessionStorage.getItem('email').toString() == "null") {
                this.selectsToDisplay[5] = "";
                this.selectsToDisplayFull[5] = "";
              }
              else {
                this.selectsToDisplay[5] = ': ' + sessionStorage.getItem('email')?.toString();
                this.selectsToDisplayFull[5] = ': ' + sessionStorage.getItem('email')?.toString();
              }
            }
            else {
              this.disabled[3] = true;
            }
            this.inicialNameStreaming(2, state);
            this.viewSVA = true;
          });
        });
      }
      else {
        this.router.navigate(['home']);
      }
    });
  }
  setCurrentIndex() {
    const set = new Observable(observer => {
      for (let i = 0; i < this.dataPlan.length; i++) {
        if (this.dataPlan.equipment == true || this.dataPlan.accesory == true) {
          this.currentParentCartId = this.dataPlan.cartId;
          this.currentParentProductId = this.dataPlan.productId;
          this.currentIndex = i;
        }
        if (this.dataPlan.plan == true) {
          this.svaIptv = true;
          this.planSelected = true;
        }
      }
      observer.next();
    });
    return set;
  }
  searchBitIncludeIptv() {
    this.svaBitInclude = [];
    for (let i = 0; i < this.sva.length; i++) {
      if (this.sva[i].bitInclude == true) {
        this.svaBitInclude.push(this.sva[i].planId);
      }
    }
  }
  resetDataSva() {
    this.selectsToDisplay[this.indexSva] = "";
    this.selectMonthlyRent[this.indexSva] = 0;
  }
  loadSva() {
    this.indexSva = 1;
    this.resetDataSva();
    this.selectsToDisplay[this.indexSva] = ': ';
    this.selectsToDisplayFull[this.indexSva] = ' ';
    this.svaCart = [];
    let countSva = 0;
    let swSva = 0;
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].iptv == true && i > 0) {
        countSva++;
      }
    }
    this.svaProducts = Boolean(countSva > 0);
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].iptv == true && i > 0) {
        for (let j = 0; j < this.sva.length; j++) {
          if (this.sva[j].planId == this.itemsCart.products[i].productId) {
            this.svaCart.push(this.sva[j].planId);
          }
        }
      }
      if (this.itemsCart.products[i].sva == true || (this.itemsCart.products[i].iptv == true && this.itemsCart.products[i].plan == false && this.itemsCart.products[i].equipment == false)) {
        if (this.itemsCart.products[i].productId != this.svaBitInclude[0] && this.itemsCart.products[i].productId != this.svaBitInclude[1] && this.itemsCart.products[i].productId != this.svaBitInclude[2] && this.itemsCart.products[i].productId != this.svaBitInclude[3]) {
        this.selectMonthlyRent[this.indexSva] += this.itemsCart.products[i].decPrice;
        if (countSva == 1) {
          this.selectsToDisplayFull[this.indexSva] += this.itemsCart.products[i].productName;
          this.selectsToDisplay[this.indexSva] += this.global.concatenateText(this.itemsCart.products[i].productName, this.global.maximumString);
        }
        else {
          if (swSva > 0) {
            this.selectsToDisplayFull[this.indexSva] += ' / ';
            this.selectsToDisplay[this.indexSva] += ' / ';
          }
          this.selectsToDisplayFull[this.indexSva] += this.itemsCart.products[i].productName;
          this.selectsToDisplay[this.indexSva] += this.global.stringCalculation(this.itemsCart.products[i].productName, countSva, this.global.maximumString);
          swSva++;
        }
      }
      }
      this.selectsToDisplay[this.indexSva] = this.global.textShortener(": " + this.selectsToDisplayFull[this.indexSva], "", 46, "...");
    }
    if (this.svaCart.length == 0) {
      this.selectsToDisplay[this.indexSva] = '';
      this.selectMonthlyRent[this.indexSva] = '';
    }
    if ((this.svaCart.length > 0 && this.changeSva == false) || this.noThanks == true) {
      //this.global.screenEnabled=true;
      this.disabled[2] = false;
      this.openTab(2);
    }
    else {
      this.disabled[2] = true;
    }
  }
  continueSva(sva: any) {
    if (sva == undefined) {
      this.noThanks = false;
      this.openTab(1);
      this.scrollToAnchor('panel_1')
      this.getCart();
    }
    else {
      if (sva == 0) {
        this.noThanks = true;
      }
      this.openTab(2);
      this.scrollToAnchor('panel_2')
      this.getCart();
    }
  }
  continueStreaming(data: any) {
    this.infoStreaming = data[0];
    this.disabled[4] = false;
    if (data[1] != 'save') {
      this.getCart(false);
    }
    else {
      this.getCart();
    }
    this.streamingValidation = true;
  }
  saveAccountIptv() {
    this.accountValidation = true;

    this.expand[3]=false;
    this.expand[4]=true;
  }
  savePaymentShipping(data: any, index: number) {
    this.selectsToDisplay[index] = data;
    this.disabled[5] = false;
    if (this.itemsCart.bitAddressValidate == false) {
      this.openTab(5);
      this.scrollToAnchor('panel_5');
      this.global.getCart().subscribe((data: any) => {
      this.itemsCart = data;
    });
    }
    else {
      this.shippingValidation = true;
      this.closeTab(4);
      this.scrollToAnchor('panel_6');
    }
  }
  saveShippingAddress(index: number) {
    this.closeTab(index);
  }
  savePlanIPTV(data: any, index: number) {
    this.selectsToDisplay[index] = data;
    this.openTab(1);
  }
  dataAddres(data: any, validate: boolean) {
    this.valueAddres = validate;
    this.dataShippingAddress = data;
    this.openTab(5);
  }
  changeIptv(index: number) {
    let makeChange = {
      state: true,
      type: 'iptv',
      productId: this.itemsCart.products[index].productId
    };
    sessionStorage.setItem("makeChange", JSON.stringify(makeChange));
    this.global.screenEnabled = true;
    this.router.navigate(['iptv/1']);
  }
  inicialNameStreaming(index: number, state: boolean = true) {
    let typeOfContract;
    let qty: number = 0;
    let equipment: boolean = false;
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].equipment == true) {
        this.installments = this.itemsCart.products[i].installments;
        if (this.itemsCart.intContractMonths == 0) {
          typeOfContract = 'Sin Contrato'
          this.selectPayToday[index] = this.itemsCart.products[i].decTotalPrice;
          this.contract = false;
        }
        else {
          if (this.installments > 0) {
            typeOfContract = this.global.stringCalculation(this.itemsCart.intContractMonths + ' Meses de Contrato | Pago en ' + this.itemsCart.products[i].installments + ' meses', 3, this.global.maximumString);

            this.contract = true;
          }
          else {
            typeOfContract = this.itemsCart.intContractMonths + ' Meses de Contrato ';
          }
        }
        qty += this.itemsCart.products[i].qty;
        this.selectsToDisplayFull[index] = ' ' + qty + ' Dispositivo  | ' + this.itemsCart.intContractMonths + ' Meses de Contrato | Pago en ' + this.itemsCart.products[i].installments + ' meses';
        this.selectsToDisplay[index] = ': ' + qty + ' Dispositivo  | ' + typeOfContract;
        equipment = true;
      }
    }
    if (state == false) {
      qty = 1;
      this.selectMonthlyRent[index] = 0;
      this.selectPayToday[index] = 0;
      this.selectsToDisplayFull[index] = '';
      this.selectsToDisplay[index] = '';
      this.contract = false;
    }
    if ((state == false || equipment == true) && (this.itemsCart.bitEquipmentValidate == true && this.itemsCart.bitAccountValidate == false)) {
      this.disabled[3] = false;
      this.scrollToAnchor('panel_3');
      this.openTab(3);
    }
    if ((state == false || equipment == true) && (this.itemsCart.bitEquipmentValidate == true && this.itemsCart.bitAccountValidate == true)) {
      this.disabled[4] = false;
      this.scrollToAnchor('panel_4');
      this.openTab(4);
    }
  }
  openTab(index: number) {
    this.expand[index] = true;
  }
  closeTab(index: number) {
    this.expand[index] = false;
  }
  back() {
   this.global.routerReturn("home")
  }
  editProcess(index: number, check: boolean) {
    if (check) {
      this.disabled[index] = !check;
    }
    else {
      this.disabled[index] = check;
      this.openTab(index);
    }
  }
}
